module.exports = __webpack_public_path__ + "img/14340395948169.834b95c4.jpg";